// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import type { BudgetPlanItem, PlanItem } from './types'
// alias workHours and salesAmount fields for mutation variables
const transformTotalSalesInput = (profitCenterId: string, dailyData: Array<BudgetPlanItem>): any =>
  dailyData.map(({ date, actualSales, actualHours }) => ({
    date,
    workHours: actualHours,
    salesAmount: actualSales,
    profitCenterId,
  }))
// prepare the daily planned data on Yhteensä page to submit
export const transformPlannedData = (dailyData: Array<PlanItem>): any =>
  dailyData.map(({ date, plannedHours, plannedSales }) => ({
    date,
    plannedHours,
    plannedSales,
  }))
// responsible for processing input for IndexSection component
export const calculateIndices = (
  plans: {
    plannedHours: number
    plannedSales: number
    plannedEfficiency: number
  },
  actuals: Record<string, any>,
) => {
  return {
    salesIndex: plans.plannedSales ? Math.round((actuals.actualSales / plans.plannedSales) * 100) : '-',
    efficiencyFactor: plans.plannedEfficiency
      ? Math.round((actuals.actualEfficiency / plans.plannedEfficiency) * 100)
      : '-',
    hoursIndex: plans.plannedHours ? Math.round((actuals.actualHours / plans.plannedHours) * 100) : '-',
  }
}

const updateBudgetedSales = (budget: BudgetPlanItem, salesIndex: number) => {
  return {
    ...budget,
    budgetedSales: Math.round(budget.budgetedSales * salesIndex) / 100,
  }
}

const updateBudgetedHours = (budget: BudgetPlanItem, hoursIndex: number) => {
  return {
    ...budget,
    budgetedHours: Math.round(budget.budgetedHours * hoursIndex) / 100,
  }
}
